import React from 'react';
import type { PanelInterventionDetail } from '../InterventionsCreate';

interface InterventionParamsSectionProps {
  d: PanelInterventionDetail | null;
  scenarioKind: 'aucun' | 'tuto' | 'exceptionnelle';
  setScenarioKind: (v: 'aucun' | 'tuto' | 'exceptionnelle') => void;
}

const inputCls = 'w-full rounded-lg border border-[#2a3a62] bg-[#0a132b] px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-[#3d4fdb]/60';

const NumberInput: React.FC<{ name: string; defaultValue: number; min?: number; label: string }> = ({
  name,
  defaultValue,
  min = 0,
  label,
}) => (
  <div>
    <label className="block text-xs font-medium text-slate-400 mb-1.5">{label}</label>
    <input type="number" name={name} defaultValue={defaultValue} min={min} className={inputCls} />
  </div>
);

const InterventionParamsSection: React.FC<InterventionParamsSectionProps> = ({
  d,
  scenarioKind,
  setScenarioKind,
}) => (
  <>
    <NumberInput name="temps_max" defaultValue={d?.params?.temps_max ?? 15} min={1} label="Temps max (minutes)" />
    <NumberInput name="victimes_min" defaultValue={d?.params?.victimes_min ?? 0} label="Victimes (min)" />
    <NumberInput name="victimes_max" defaultValue={d?.params?.victimes_max ?? 0} label="Victimes (max)" />
    <NumberInput name="hostiles_min" defaultValue={d?.params?.hostiles_min ?? 0} label="Hostiles (min)" />
    <NumberInput name="hostiles_max" defaultValue={d?.params?.hostiles_max ?? 0} label="Hostiles (max)" />
    <NumberInput name="vehicules_accidentes_min" defaultValue={d?.params?.vehicules_accidentes_min ?? 0} label="Véhicules accidentés (min)" />
    <NumberInput name="vehicules_accidentes_max" defaultValue={d?.params?.vehicules_accidentes_max ?? 0} label="Véhicules accidentés (max)" />

    <div className="md:col-span-2 border-t border-[#1e2d4d] pt-4 mt-2">
      <label className="block text-xs font-medium text-slate-400 mb-1.5">
        Récompense de l'intervention
      </label>
      <p className="text-xs text-slate-500 mb-3">XP et € accordés une fois l'intervention terminée.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs text-slate-400 mb-1.5">XP</label>
          <input type="number" name="recompense_xp" defaultValue={d?.recompense?.xp ?? 0} min={0} className={inputCls} />
        </div>
        <div>
          <label className="block text-xs text-slate-400 mb-1.5">€</label>
          <input type="number" name="recompense_credits" defaultValue={d?.recompense?.credits ?? 0} min={0} className={inputCls} />
        </div>
      </div>
    </div>

    <div className="md:col-span-2 space-y-3">
      <p className="text-xs text-slate-500">
        Type de scénario (optionnel) : choisir au plus une option — tutoriel ou exceptionnelle, pas les deux.
      </p>
      <label className="flex items-center space-x-3 cursor-pointer">
        <input
          type="checkbox"
          checked={scenarioKind === 'tuto'}
          onChange={(e) => setScenarioKind(e.target.checked ? 'tuto' : 'aucun')}
          className="w-4 h-4 rounded"
        />
        <span className="text-sm font-medium text-slate-300">Intervention tutoriel</span>
        <span className="text-xs text-slate-400">(Destinée à l&apos;apprentissage)</span>
      </label>
      <label className="flex items-center space-x-3 cursor-pointer">
        <input
          type="checkbox"
          checked={scenarioKind === 'exceptionnelle'}
          onChange={(e) => setScenarioKind(e.target.checked ? 'exceptionnelle' : 'aucun')}
          className="w-4 h-4 rounded"
        />
        <span className="text-sm font-medium text-slate-300">Intervention exceptionnelle</span>
        <span className="text-xs text-slate-400">(Événement rare ou hors routine)</span>
      </label>
    </div>
  </>
);

export default InterventionParamsSection;
